<!--pagination-->
<template>
  <div class="panel panel__pagination">
    <div class="panel__content panel__content--pagination">
      <div class="pagination pagination__container flex-box-ends">
        <!-- pagination content -->
        <div class="pagination__content__left">
          <!--{{transferProp.pagination.current_page}}-->
          <input id="currentPage" class="pagination__current-page form__input" @keyup.enter="setUrlParams(paginationData.currentPage, null)" v-model="paginationData.currentPage"/>
          <div class="pagination__total-pages">of {{paginationData.totalPages}} </div>
          <!--{{paginationData.totalPages}}-->
          <div class="pagination__current-limit select">
            <span class="showing-text">Showing</span>
            <select name="" id="" class="select__input select__input--sm input--fake-padding" v-model="perPageSelected" @change="setUrlParams(null, perPageSelected)">
              <option value="" disabled>Page numbers</option>
              <option value="10"> 10 per page</option>
              <option value="20"> 20 per page</option>
              <option value="30"> 30 per page</option>
              <option value="40"> 40 per page</option>
              <option value="50"> 50 per page</option>
            </select>
            <div class="select__icon select__icon--in-pagination select__icon--right">
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path fill-rule="evenodd" d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z" fill="#42476f"></path></svg>
            </div>
          </div>
        </div>
        
        <div class="pagination__content__right">
          
          <!-- Pagination item -->
          <div class="pagination__item pagination__item--prev">
            <!-- pagination prev link -->
            <button class="btn btn--default" :disabled="isFirstPage()" @click="setUrlParams(paginationData.currentPage - 1, null)">Previous</button>
          </div>
          
          <!-- Pagination item -->
          <div class="pagination__item" v-for="number in 11" v-if="getPaginationCount(number)">
            <!-- pagination link -->
            <button class="btn btn--default pagination__item__link" :class="{'active':paginationData.currentPage === getPaginationCount(number)}" @click ="setUrlParams(getPaginationCount(number), null)">{{getPaginationCount(number)}}</button>
          </div>
          
          <!-- Pagination item -->
          <div class="pagination__item pagination__item--next">
            <!-- pagination next link -->
            <button class="btn btn--default" :disabled="isLastPage()" @click="setUrlParams(paginationData.currentPage + 1, null)">Next</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .panel__pagination{
      z-index:2;
      position:relative;
  }
</style>

<script>
  export default {
    
    mounted(){
      if(this.paginationData.perPage >= 10){
        this.perPageSelected = this.paginationData.perPage;
      }

    },
    
    data(){
      return{
        perPageSelected:10,
        pageNumber:1,
        paginationData:{
          perPage:this.paginationProp.pagination.per_page,
          currentPage: this.paginationProp.pagination.current_page,
          totalPages: this.paginationProp.pagination.total_pages,
          url: this.paginationProp.pagination.url
        }
      }
    },
    
    computed:{
      paginationStart(){
        
        if(this.paginationData.currentPage > 6){
          return this.paginationData.currentPage - 6;
        }
        else{
          return 0;
        }
      },
      
    },
  
    
    props: [
      'paginationProp'
    ],
    
    methods:{
      setUrlParams(page, per_page){
        if(page == null){
          page = this.paginationData.currentPage;
        }
        if(per_page == null){
          per_page = this.paginationData.perPage;
        }
//        this.$router.push('/transfers/all/?page=' +page+'&per_page='+per_page)
       this.$router.push('?page=' +page+'&per_page='+per_page);
        location.reload()
      },
      
      isFirstPage(){
        return this.paginationData.currentPage === 1
      },
  
      isLastPage(){
        return this.paginationData.currentPage === this.paginationData.totalPages
      },
      
      //get pagination count
      getPaginationCount(number){
        let pageNumbers = this.paginationStart + number;
        if(pageNumbers > this.paginationData.totalPages){
          return false;
        }
        return pageNumbers;
      }
    }
    
  }
</script>




// WEBPACK FOOTER //
// src/components/partials/PaginationView.vue